import { render, staticRenderFns } from "./InvoiceHistory.vue?vue&type=template&id=bfcabbd6&scoped=true&"
import script from "./InvoiceHistory.vue?vue&type=script&lang=js&"
export * from "./InvoiceHistory.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceHistory.vue?vue&type=style&index=0&id=bfcabbd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcabbd6",
  null
  
)

export default component.exports